var _defs, _rect, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack364({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.12,
    y: 2.75,
    width: 10.28,
    height: 4.61,
    transform: "translate(3.37 -2.45) rotate(30)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "11.04 7.82 13.19 11.54 15.34 7.82 11.04 7.82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.85,14.11l.49-.06c.08.53.31.8.68.8a.67.67,0,0,0,.46-.18,1.24,1.24,0,0,0,.35-.61A3.2,3.2,0,0,0,5,13v-.12a1.33,1.33,0,0,1-.43.48.94.94,0,0,1-.54.18,1.13,1.13,0,0,1-.87-.44,1.83,1.83,0,0,1-.36-1.2,1.87,1.87,0,0,1,.38-1.24,1.16,1.16,0,0,1,.92-.45,1.14,1.14,0,0,1,.71.25,1.63,1.63,0,0,1,.51.74,4.33,4.33,0,0,1,.18,1.42,5.16,5.16,0,0,1-.19,1.6,1.77,1.77,0,0,1-.53.84,1.2,1.2,0,0,1-.75.26A1,1,0,0,1,3.23,15,1.53,1.53,0,0,1,2.85,14.11Zm2.07-2.22a1.33,1.33,0,0,0-.24-.84.68.68,0,0,0-.55-.31.72.72,0,0,0-.58.33A1.39,1.39,0,0,0,3.3,12a1.19,1.19,0,0,0,.24.78.72.72,0,0,0,.58.29.69.69,0,0,0,.57-.29A1.31,1.31,0,0,0,4.92,11.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6,12.8a4.37,4.37,0,0,1,.34-1.92,1.08,1.08,0,0,1,1-.64,1,1,0,0,1,.92.52,3.82,3.82,0,0,1,.41,2,4.16,4.16,0,0,1-.34,1.9,1.08,1.08,0,0,1-1,.65,1.12,1.12,0,0,1-1-.57A3.82,3.82,0,0,1,6,12.8Zm.52,0a3.91,3.91,0,0,0,.23,1.64.7.7,0,0,0,.6.42.67.67,0,0,0,.58-.42,3.77,3.77,0,0,0,.24-1.64,3.66,3.66,0,0,0-.24-1.63.7.7,0,0,0-.61-.42.66.66,0,0,0-.57.42A3.92,3.92,0,0,0,6.49,12.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack364);
export default __webpack_public_path__ + "static/media/Symbol_pack_364.3c670e104c871fd5bfe2f9514553da2c.svg";
export { ForwardRef as ReactComponent };